import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import Stack from '../Stack';
import styles from './Information.module.css';

const bindClasses = classNameBind.bind(styles);

const displayIcon = (type) => {
  switch (type) {
    case 'error':
      return <Icon name="exclamation-mark-circle" color="red" />;
    case 'warning':
      return <Icon name="exclamation-mark-circle" color="yellow" />;
    case 'success':
      return <Icon name="checkmark-circle" color="green" />;
    case 'info':
      return <Icon name="info-circle" color="blue" />;
    default:
      return null;
  }
};

const Information = ({
  children,
  type,
  dataId,
}) => (
  <div className={bindClasses('wrapper', type)} data-ppuc-id={dataId}>
    <div className={bindClasses('wrapper-inside')}>
      <Stack verticalAlignment="center" spacing="narrow">
        <Stack.Item>
          <div className={bindClasses('icon')}>
            {displayIcon(type)}
          </div>
        </Stack.Item>
        <Stack.Item fill>
          <div className={bindClasses('text')}>
            {children}
          </div>
        </Stack.Item>
      </Stack>
    </div>
  </div>
);

Information.defaultProps = {
  dataId: 'Information',
};

export default Information;
